import React from "react";
import {Col, Layout, Row} from "antd";
import {Link} from "react-router-dom";
import {UserMenu} from "../UserMenu/UserMenu";
import {FormattedDate} from "../../DesignSystem/Moment/FormattedDate";
import PropTypes from "prop-types";
import {TopHeaderHelp} from "./TopHeaderHelp";
import {LogoPart} from "../../apps/default/LogoPart";

const {Header} = Layout;

const TopHeader = ({user}) => {



    return <Header style={{borderBottom: '1px solid #f0f0f0'}}>
        <Row>
            <Col sm={24}>
                <LogoPart/>
                <TopHeaderHelp/>&nbsp;&nbsp;
                <UserMenu user={user}/>
            </Col>
            {/*<Col sm={22} style={{textAlign: "right"}}>*/}
            {/*    <NotificationsContainer/>*/}
                {/*{showExpiryMessage()}*/}
                {/*<TopHeaderHelp/>&nbsp;&nbsp;*/}
                {/*<UserMenu user={user}/>*/}
            {/*</Col>*/}
        </Row>
    </Header>

}

export default TopHeader;

TopHeader.propTypes = {
    user: PropTypes.object.isRequired
}